import React, { useState } from 'react';
import { 
  MobileStepContainer, 
  MobileStepSection, 
  MobileFormItem, 
  MobileActionButton 
} from '@/components/onboarding/MobileStepContainer';
import { Check, ArrowRight } from 'lucide-react';

// Interface para os dados recebidos e para a função de callback
interface WelcomeStepMobileProps {
  data?: Record<string, any>;
  isLastStep?: boolean;
  onNext: (data: Record<string, any>) => void;
}

/**
 * Versão otimizada para mobile do passo de boas-vindas do onboarding
 */
export const WelcomeStepMobile: React.FC<WelcomeStepMobileProps> = ({ 
  data = {}, 
  isLastStep = false,
  onNext 
}) => {
  // Estado para controlar a aceitação dos termos
  const [termsAccepted, setTermsAccepted] = useState(data?.terms_accepted || false);
  
  // Função para avançar para o próximo passo
  const handleContinue = () => {
    onNext({
      viewed: true,
      completed: true,
      terms_accepted: termsAccepted
    });
  };

  return (
    <MobileStepContainer>
      {/* Seção de boas-vindas */}
      <MobileStepSection>
        <div className="text-center mb-3">
          <h1 className="text-lg font-bold mb-1">Bem-vindo ao Zapcore</h1>
          <p className="text-xs text-gray-600">
            Vamos configurar seu assistente virtual inteligente em poucos passos.
          </p>
        </div>
      </MobileStepSection>

      {/* Seção de benefícios */}
      <MobileStepSection 
        title="O que você vai conseguir fazer:"
        className="bg-blue-50 border-blue-100"
      >
        <ul className="space-y-1.5">
          {[
            "Atender seus clientes 24/7 com WhatsApp automatizado",
            "Responder dúvidas com inteligência artificial",
            "Gerenciar agendamentos e lembretes",
            "Personalizar seu assistente para o seu negócio"
          ].map((item, index) => (
            <li key={index} className="flex items-start gap-1.5">
              <Check className="h-4 w-4 text-green-500 flex-shrink-0 mt-0.5" />
              <span className="text-xs">{item}</span>
            </li>
          ))}
        </ul>
      </MobileStepSection>

      {/* Seção de termos */}
      <MobileStepSection>
        <MobileFormItem>
          <div className="flex items-start gap-2">
            <input
              type="checkbox"
              id="terms"
              checked={termsAccepted}
              onChange={() => setTermsAccepted(!termsAccepted)}
              className="h-4 w-4 mt-0.5"
            />
            <label htmlFor="terms" className="text-xs">
              Ao prosseguir, você concorda com nossos <a href="/terms" target="_blank" className="text-primary underline">Termos de Serviço</a> e <a href="/privacy" target="_blank" className="text-primary underline">Política de Privacidade</a>.
            </label>
          </div>
        </MobileFormItem>

        <div className="mt-4">
          <MobileActionButton
            onClick={handleContinue}
            disabled={!termsAccepted}
            className="flex items-center justify-center gap-1.5 text-sm"
          >
            Iniciar Configuração <ArrowRight className="h-3.5 w-3.5" />
          </MobileActionButton>
        </div>
      </MobileStepSection>
    </MobileStepContainer>
  );
}; 